export class TagStagePhase {
  // Clases de etapas
  public static readonly CLASS_STAGE_HIERARCHY_1: string = 'tag--hierarchy-1';
  public static readonly CLASS_STAGE_HIERARCHY_2: string = 'tag--hierarchy-2';
  public static readonly CLASS_STAGE_HIERARCHY_3: string = 'tag--hierarchy-3';
  public static readonly CLASS_STAGE_HIERARCHY_4: string = 'tag--hierarchy-4';
  public static readonly CLASS_STAGE_HIERARCHY_5: string = 'tag--hierarchy-5';
  public static readonly CLASS_STAGE_HIERARCHY_6: string = 'tag--hierarchy-6';
  public static readonly CLASS_STAGE_HIERARCHY_7: string = 'tag--hierarchy-7';
  public static readonly CLASS_STAGE_HIERARCHY_8: string = 'tag--hierarchy-8';
  public static readonly CLASS_STAGE_HIERARCHY_9: string = 'tag--hierarchy-9';
  public static readonly CLASS_STAGE_HIERARCHY_10: string = 'tag--hierarchy-10';
}
